export default __webpack_public_path__ + "static/media/Foto-20.7e859caf.png";